module.exports = "<private-bus-request-page></private-bus-request-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/privatebusrequest.html
// module id = 1944
// module chunks = 0